const Anything = {};

// Empty propTypes needed in order for Anything.cs to be generated.
Anything.propTypes = {};

// This component exists in order to generate Anything.cs, and to be able to reference this class in propTypes. Use Anything.propTypes to describe a prop where a valid value can be any object. For an example, see ProductCard, where this class is used to represent arbitrary analytics data to be received from the server
export default Anything;
